// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3_-wf","inputWrap":"Table_inputWrap__2oj-w","col":"Table_col__1bdTh","bmiTooltip":"Table_bmiTooltip__10Gjk"};